import i18next from "i18next";
export const i18n = process.env.NODE_ENV === "test" ? i18next : /* istanbul ignore next */i18next.default || i18next;
export * from "./init.js";
export * from "./text.js";
//# sourceMappingURL=index.js.map